<fm-menu-bar [iconStyle]="{'font-size':'13px'}" [menu]="menu"> </fm-menu-bar>

<app-system-down *ngIf="showSystemDown"
    [title]="systemDownFlagValue.title"
    [message]="systemDownFlagValue.message">
</app-system-down>
